import moment from 'moment';

export const dateTimeRegex = /^(\d{4}-\d{1,2}-\d{1,2})(T\d{1,2}:\d{1,2}:\d{1,2}([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?$/;
export const dateRegex = /^(\d{4}-\d{1,2}-\d{1,2})(T0+:0+:0+)?$/;
export const toDate = function(value) {
  if (typeof value === 'undefined' || value === null) return value;
  var match;
  var matchDate;
  if (typeof value === 'string') {
    if (value.toLowerCase() === 'today')
      return moment
        .utc()
        .startOf('day')
        .toDate();
    if ((match = value.match(dateTimeRegex))) {
      var milliseconds;
      if ((matchDate = value.match(dateRegex))) milliseconds = Date.parse(matchDate[1]);
      else milliseconds = Date.parse(match[0]);
      if (!isNaN(milliseconds)) {
        return new Date(milliseconds);
      }
    }
  }
  if (value instanceof Date) return value;
  return undefined;
};
